import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import CopyText from './components/CopyText.vue'

Vue.use(ElementUI)
Vue.component('CopyText', CopyText)
Vue.config.productionTip = false

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.isApiError) {
    event.preventDefault()
  }
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
